import { DEFAULT_LANGUAGE } from 'src/constants/constants';

import type { Questionnaire } from 'fhir/r4';

import { getLanguageLocaleFromString, LanguageLocales } from './portalLanguage-utils';

const PRIORITY_ORDER = [
  LanguageLocales.NORWEGIAN,
  LanguageLocales.NORWEGIAN_NYNORSK,
  LanguageLocales.SAMI_NORTHERN,
  LanguageLocales.ENGLISH,
  LanguageLocales.POLISH,
  LanguageLocales.UKRAINIAN,
  LanguageLocales.LITHUANIAN,
  LanguageLocales.ROMANIAN,
  LanguageLocales.FRENCH,
  LanguageLocales.RUSSIAN,
  LanguageLocales.INGEN,
];

export const sortLanguages = (languages: LanguageLocales[]): LanguageLocales[] => {
  return [...languages].sort((a, b) => {
    const indexA = PRIORITY_ORDER.indexOf(a);
    const indexB = PRIORITY_ORDER.indexOf(b);

    const aIsPriority = indexA !== -1;
    const bIsPriority = indexB !== -1;

    if (aIsPriority && bIsPriority) {
      return indexA - indexB;
    }

    if (aIsPriority) return -1;
    if (bIsPriority) return 1;

    return a.localeCompare(b, 'nb', { sensitivity: 'base' });
  });
};

export const getLanguagesInDefinition = (questionnaires: Questionnaire[]): LanguageLocales[] => {
  const languageArray = questionnaires?.map(q => {
    return getLanguageLocaleFromString(q.language) ?? DEFAULT_LANGUAGE;
  });
  const arraySorted = sortLanguages(languageArray);
  return arraySorted;
};
